// Robust clipboard copy with fallback for restricted environments (e.g. preview
// where the async Clipboard API is blocked by permissions policy).
export async function copyToClipboard(text) {
  const value = String(text ?? "");
  // 1) Modern async Clipboard API (works in a secure top-level context / production)
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (e) {
    // fall through to legacy method
  }
  // 2) Legacy fallback. IMPORTANT: append the textarea INSIDE the open dialog (if any) so it
  // stays within Radix's focus-scope — otherwise the dialog's focus trap steals focus back and
  // execCommand('copy') copies an empty selection (this was why Copy "did nothing" in modals).
  try {
    const host = document.querySelector('[role="dialog"]') || document.body;
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.width = "1px";
    ta.style.height = "1px";
    ta.style.opacity = "0";
    host.appendChild(ta);
    ta.focus({ preventScroll: true });
    ta.select();
    ta.setSelectionRange(0, value.length);
    const ok = document.execCommand("copy");
    host.removeChild(ta);
    if (ok) return true;
  } catch (e) {
    // ignore
  }
  return false;
}
